import Medici from "../";
const routes = [
  { name: "ConfigurazioneMedicoListPage", path: "/medici", component: Medici.ConfigurazioneMedicoListPage, meta: { title: "Configurazione Medici" } },
  { name: "ConfigurazioneMedicoEditPage", path: "/medici/edit/:id", component: Medici.ConfigurazioneMedicoEditPage, meta: { title: "Configurazione Medici" } }
];

export default routes;
